/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_On_This_PageInputs */

const en_legal_on_this_page = /** @type {(inputs: Legal_On_This_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On this page`)
};

const pl_legal_on_this_page = /** @type {(inputs: Legal_On_This_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na tej stronie`)
};

/**
* | output |
* | --- |
* | "On this page" |
*
* @param {Legal_On_This_PageInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const legal_on_this_page = /** @type {((inputs?: Legal_On_This_PageInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_On_This_PageInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_legal_on_this_page(inputs)
	return en_legal_on_this_page(inputs)
});